<template>
  <div class="mainContaner full_w" style="height: 100%;background-color: #f5f5f5">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <!--header-->
      <!--<div class="nav_bar">-->
        <!--<button class="clear_style fl nav_bar_left_item" style="width: 2rem;height: 2rem" ><img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" ></button>-->
        <!--<p class="clear_style fl nav_bar_search tc">编辑收货地址</p>-->
      <!--</div>-->

      <!--content-->
      <div class="cart_content">
        <van-address-edit
          :area-list="areaList"
          :address-info="addressInfo"
          :show-delete="isEdit"
          show-set-default
          show-search-result
          :area-columns-placeholder="['请选择', '请选择', '请选择']"
          @confirm="onConfirm"
          @change-area="changeArea"
          @save="onSave"
          @delete="onDelete"
        />
      </div>

    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { postalAddressAdd,postalAddressModify,postalAddressDelete } from '@/router/api';
  import { setStore,getStore } from '@/utils/mUtil';
  import { Image,Button } from 'vant';
  import { Overlay,PullRefresh,Toast,AddressEdit,Area } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';
  import areaList from '@/utils/areaList';

  export default {
    name: 'address_add',
    data() {
      return {
        token:"",
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        totalPrices:0,
        showLoading:true,
        isEdit:this.$route.query.isEdit,
        areaList,
        id:this.$route.query.id,
        partyName:this.$route.query.toName,
        phone:this.$route.query.contactNumber,
        province:this.$route.query.province,
        city:this.$route.query.city,
        district:this.$route.query.district,
        address:this.$route.query.address,
        isDefault:this.$route.query.isDefault,
        countyGeoId:this.$route.query.countyGeoId,
        addressInfo:[],
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      [AddressEdit.name]: AddressEdit,
      [Area.name]: Area,
      footerView,
      loading,
      refresh
    },
    methods:{
      async initData() {
        this.addressInfo = {
          id:this.id,
          name:this.partyName,
          tel:this.phone,
          province:this.province,
          city:this.city,
          county:this.district,
          addressDetail:this.address,
          areaCode:this.countyGeoId,
          isDefault:this.isDefault == 1? true:false,
        }
        setTimeout(() => {
          this.showLoading = false;
        }, 1000);
      },
      /**
       * parameters:
       * {
       *    partyName
       *    token
       *    phone
       *    province
       *    city
       *    district
       *    address
       *    isDefault
       * }
       */
      postalAddressAdd() {
        console.log("province===="+this.province)
        postalAddressAdd({externalLoginKey:getStore('externalLoginKey'),contactMechId:this.id,partyName:this.partyName,phone:this.phone,province:this.province,city: this.city,district:this.district,address:this.address,isDefault:this.isDefault,productStoreId: storeName})
          .then(res => {
            console.log("postalAddressAdd")
            console.log(res)
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {
              Toast(res._EVENT_MESSAGE_);
              this.$router.back(-1);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      postalAddressModify() {
        console.log("city="+this.city)
        postalAddressModify({externalLoginKey:getStore('externalLoginKey'),contactMechId:this.id,partyName:this.partyName,phone:this.phone,province:this.province,city: this.city,district:this.district,address:this.address,isDefault:this.isDefault,productStoreId: storeName})
          .then(res => {
            console.log("postalAddressAdd")
            console.log(res)
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {
              Toast(res._EVENT_MESSAGE_);
              this.$router.back(-1);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      postalAddressDelete() {
        postalAddressDelete({externalLoginKey:getStore('externalLoginKey'),contactMechId:this.id})
          .then(res => {
            console.log("postalAddressDelete")
            console.log(res)
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {
              Toast(res._EVENT_MESSAGE_);
              this.$router.back(-1);
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      onSave (content){
        console.log(content)
        this.partyName = content.name;
        this.phone = content.tel;
        this.address = content.addressDetail;
        this.isDefault = content.isDefault;
        if (content.isDefault == true) {
          this.isDefault = 1;
        } else {
          this.isDefault = 0;
        }
        if (this.id == "" || this.id == undefined) {
          this.postalAddressAdd();
        } else {
          this.postalAddressModify();
        }
      },
      onDelete (content){
        console.log(content)
        this.postalAddressDelete();
      },
      onConfirm(content){
        console.log(content)
      },
      changeArea(values) {
        this.province = values[0].code;
        this.city = values[1].code;
        this.district = values[2].code;
      },

      // 数据格式化
      resetScorllView() {
        this.$router.afterEach((to,from, next) => {
          window.scrollTo(0,0)
        })
      }
    },
    mounted() {
      this.initData();
      this.resetScorllView();
    }

  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .cart_content {
    padding-bottom: 3rem;
  }

  .animate_action {
    transition:all .4s;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/order/address_add.vue